// @ commons
const { WIZARD_FIRST_STEP, } = require('constants/index');
// @ constants
const { GENERAL_DATA } = require('constants/mortgageRequestMortgageDataTypes');
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS, MORTGAGE_GENERIC_ALIAS }, URL_TYPEC, URL_TYPE_A_B
} = require('./index');

const poeditorPrefix = 'bannerNominaLoanCollectives';
const poeditorMortgagePrefix = 'bannerCollectivesMortgages';
const { PERSONAL_LOAN_WAFFER,
    EASY_LOAN_WAFFER,
    RETAIL_LOAN_WAFFER,
    OVERDRAFT_LOAN_WAFFER
} = require('constants/flagBasedFeatures');

export const getLoansCreditsMortgagesProductBanners = (productSubType) => {

    const LOANS_CREDITS_MORTGAGES_PRODUCT_BANNERS = [
        {
            id: 'easyLoan',
            sidebarImgAlt: 'bannerEasyLoan-title',
            featureFlag: EASY_LOAN_WAFFER,
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/prestamo_facil.jpg',
            subtitle: 'bannerEasyLoan-subtitle',
            link: productSubType === '810' ? URL_TYPEC : URL_TYPE_A_B
        },
        {
            id: 'retailLoan',
            featureFlag: RETAIL_LOAN_WAFFER,
            subtitle: 'retailLoanCommon-bannerComercialTitle',
            link: 'retailLoanCommon-seeAllEvents'
        },
        {
            id: 'mortgage', // mortgages
            title: 'banner123806-title',
            featureFlag: null,
            productTypeId: GENERAL_DATA.PRODUCT_NUMBER,
            sidebarImgAlt: "banner123806-title",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/hipoteca_open.jpg',
            subtitle: 'banner123806-subtitle',
            advantages: [
                {
                    text: 'banner123806-advantage03',
                    icon: 'bannerMortgages-bannerMortgages_advantage01'
                },
                {
                    text: 'banner123806-advantage02',
                    icon: 'bannerMortgages-bannerMortgages_advantage02'
                },
                {
                    text: 'banner123806-advantage05',
                    icon: 'bannerMortgages-bannerMortgages_advantage03'
                },
                {
                    text: 'banner123806-advantage04',
                    icon: 'bannerMortgages-bannerMortgages_advantage04'
                }
            ],
            collective: {
                alias: MORTGAGE_GENERIC_ALIAS,
                subtitle: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_subtitle`,
                advantages: [
                    {
                        text: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_advantage01`,
                        icon: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_iconAdvantage01`
                    },
                    {
                        text: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_advantage02`,
                        icon: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_iconAdvantage02`
                    },
                    {
                        text: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_advantage03`,
                        icon: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_iconAdvantage03`
                    },
                    {
                        text: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_advantage04`,
                        icon: `${poeditorMortgagePrefix}-${poeditorMortgagePrefix}_iconAdvantage04`
                    }
                ],
            },
            link: '/myprofile/mortgage/pre-approval'
        },
        {
            id: 'nominaLoan',
            title: 'bannerNominaLoan-title',
            featureFlag: PERSONAL_LOAN_WAFFER,
            sidebarImgAlt: "bannerNominaLoan-title",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/prestamo_nomina.jpg',
            subtitle: 'bannerNominaLoan-subtitle',
            advantages: [
                {
                    text: 'bannerNominaLoan-advantage01',
                    icon: 'icon-interes-competitivo'
                },
                {
                    text: 'bannerNominaLoan-advantage02',
                    icon: 'icon-libertad-cambio'
                },
                {
                    text: 'bannerNominaLoan-advantage03',
                    icon: 'icon-tiempo'
                },
                {
                    text: 'bannerNominaLoan-advantage04',
                    icon: 'icon-especialista'
                }
            ],
            link: `/myprofile/loans-mortgages/request-payroll-loan/0/${WIZARD_FIRST_STEP}`,
            collective: {
                alias: PAYROLL_LOAN_ALIAS,
                subtitle: 'bannerNominaLoanCollectives-subtitle',
                advantages: [
                    {
                        text: `${poeditorPrefix}-${poeditorPrefix}_advantage01`,
                        icon: 'icon-interes-competitivo'
                    },
                    {
                        text: `${poeditorPrefix}-${poeditorPrefix}_advantage02`,
                        icon: 'icon-libertad-cambio'
                    },
                    {
                        text: 'bannerNominaLoan-advantage03',
                        icon: 'icon-tiempo'
                    },
                    {
                        text: 'bannerNominaLoan-advantage04',
                        icon: 'icon-especialista'
                    }
                ],
            },
        },
        {
            id: 'pregrantedCredit', //this is used to identify tag new
            title: 'bannerPregrantedCredit-title',
            featureFlag: OVERDRAFT_LOAN_WAFFER,
            sidebarImgAlt: "bannerPregrantedCredit-title",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/proteccion_descubierto.jpg',
            subtitle: 'bannerPregrantedCredit-subtitle',
            advantages: [
                {
                    text: 'bannerPregrantedCredit-advantage01',
                    icon: 'icon-comodidad'
                },
                {
                    text: 'bannerPregrantedCredit-advantage02',
                    icon: 'icon-cuentas'
                },
                {
                    text: 'bannerPregrantedCredit-advantage03',
                    icon: 'icon-tiempo'
                },
                {
                    text: 'bannerPregrantedCredit-advantage04',
                    icon: 'icon-0-euro'
                }
            ],
            link: '/myprofile/loans-mortgages/pre-granted-credit'
        }
    ];
    return LOANS_CREDITS_MORTGAGES_PRODUCT_BANNERS;
};
